import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    type: 'deposit', // 'deposit', 'withdraw', 'history'
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPaymentType: (state, action) => {
            state.type = action.payload;
        },
        clearPaymentType: (state) => {
            state.type = 'deposit';
        },
    },
});

export const { setPaymentType, clearPaymentType } = paymentSlice.actions;
export default paymentSlice.reducer;
